import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Button, Modal } from 'antd';
import { deleteClasse, getClasse } from './classe.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ClasseDeleteModal = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useAppDispatch();
  const classe = useAppSelector(state => state.classe.entity);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const showModal = () => {
    setIsModalVisible(true);
  };
  useEffect(() => {
    dispatch(getClasse(props.match.params.id));
  }, [props.match.params.id]);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/classe/${currentEcole && currentEcole.id}`);
  };

  const confirmDelete = event => {
    const entity = {
      ecoleId: props.match.params.ecoleid,
      id: props.match.params.id,
    };
    dispatch(deleteClasse(entity));
    handleClose(event);
  };

  const goBack = () => {
    props.history.goBack();
  };

  return (
    <Modal
      title="Confirmation de suppression"
      centered
      footer={[
        <Button key="back" onClick={goBack}>
          Annuler
        </Button>,
        <Button key="submit" style={{ backgroundColor: '#cd201f', color: 'white' }} onClick={confirmDelete}>
          Supprimer
        </Button>,
      ]}
      visible={true}
      closable={false}
    >
      Etes-vous certain de vouloir supprimer la classe de {classe.nom} ?
    </Modal>
  );
};

export default ClasseDeleteModal;
